import styled from 'styled-components'

export const AboutButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #0085ff;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  white-space: nowrap;
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
    font-size: 16px;
  }

  &:hover,
  &:focus {
    color: #0085ff;
    background: rgba(0, 133, 255, 0.08);
    outline: none;
  }
`
